/*
 * Created by: bpietroiu
 * Date: 7/16/13  10:33 AM
 */

TS.ns('TS.domain.properties.fields');

/**
 * @class TS.domain.properties.fields.BrowseListField
 * @extends TS.domain.properties.fields.SelectionListField
 */
TS.domain.properties.fields.BrowseListField = new Class(
    /** @lends TS.domain.properties.fields.BrowseListField# */
    {
        Extends: TS.domain.properties.fields.SelectionListField,

        initialize: function (owner, config) {
            var me = this;

            me.parent(owner, config);
            
            var domain = me.Domain(),
                propertyName = owner.Name + '.Fields.' + me.Name;
            me.browseUrl = TS.unwrap(TS.Util.removeTrailingSlash(domain.rootUrl)) + '/' + 'BrowseProperty?propertyName=' + propertyName;
        },
    });

TS.domain.properties.ListField.types['browse'] = TS.domain.properties.fields.BrowseListField;
